define('mailsMailHeaderLabelsAddDatalistView',[
  'module',
  'marionette',
  'underscore',
  'inputView',
  'mailsMailHeaderLabelsAddDatalistOptionView'
], function (
  Module,
  Marionette,
  _,
  InputView,
 OptionView
) {
  'use strict';

  Module.exports = Marionette.CollectionView.extend({   
    tagName: 'datalist',
    childView: OptionView,

    attributes: function () {
      return {
        'id': this.options.id
      };
    }
  });
});
  
